export default __webpack_public_path__ + "static/media/whatsapp.3c6b3aa3.svg";